import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { ApiService } from '../../api.service';
import { ToastrService } from 'ngx-toastr';
import moment from 'moment';

@Component({
	selector: 'app-report',
	templateUrl: './report.component.html',
	styleUrl: './report.component.scss'
})
export class ReportComponent implements OnInit, AfterViewInit {
	breadcrumbList: any[] = [];
	refNo: any = null;
	pagetitle = "Report";
	pageLoading1: boolean = false;
	pageLoading2: boolean = false;
	apptList: any[] = [];
	scoreList: any[] = [];
	selectedAppt: any = null;
	selectedApptWithScore: any = null;
	homeRoute = this.apiService.getHomeURL();

	constructor(private toastr: ToastrService, private apiService: ApiService, private router: Router, private activeRoute: ActivatedRoute) { }

	ngAfterViewInit(): void { }

	ngOnInit(): void {
		this.activeRoute.params.subscribe(routeParams => {
			this.refNo = routeParams["refNo"];
			this.breadcrumbList = [
				{ path: this.homeRoute, name: "Home" },
				{ path: "/app/report/" + this.refNo, name: this.pagetitle }
			]
			this.getDetails();
		});
	}

	getDetails() {
		this.pageLoading1 = true;
		this.apiService.getApptDetails(this.refNo).subscribe({
			next: (data: any) => {
				this.pageLoading1 = false;
				this.apptList = data;
				this.selectedAppt = this.apptList[0].encrypt_id;
				this.getScore();
			}, error: (error) => {
				this.pageLoading1 = false;
				this.apptList = [];
				if (error.status == 401) { return }
				this.toastr.error("Unable to fetch details.", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	getScore() {
		if (this.selectedAppt) {
			this.pageLoading2 = true;
			this.apiService.getScorelist(this.selectedAppt).subscribe({
				next: (data: any) => {
					this.pageLoading2 = false;
					this.selectedApptWithScore = data;
				}, error: (error) => {
					this.pageLoading2 = false;
					this.selectedApptWithScore = null;
					if (error.status == 401) { return }
					this.toastr.error("Unable to fetch details.", 'Error', {
						timeOut: 3000,
						tapToDismiss: true,
						closeButton: true
					});
				}
			});
		} else {
			this.selectedApptWithScore = null;
		}
	}

	formatDate(dateStr: string) {
		try {
			if (dateStr) {
				return moment(dateStr, "YYYY-MM-DD").format("DD-MM-YYYY");
			} else {
				return dateStr;
			}
		} catch (error) {
			return dateStr;
		}
	}
}
